import feedbackData2024 from './2024'
import feedbackData2025 from './2025'

export const feedbackData = {
  2024: feedbackData2024,
  2025: feedbackData2025,
}
